import { useMemo } from "react";

import { queryKeys } from "../queryKeys";
import { getOrders, type Order } from "../rest/account";
import { useRequest } from ".";
import type { QueryOptions } from "./useRequest";

type UseGetOrdersArgs = {
  accountID?: string;
  product?: string;
  status?: "open" | "closed" | "all";
  side?: "buy" | "sell" | "sell_short";
  limit?: number;
  options?: QueryOptions<Order[]>;
};

export const useGetOrders = ({
  accountID,
  product,
  status,
  side,
  limit,
  options,
}: UseGetOrdersArgs) => {
  const { data, refetch, isLoading } = useRequest(
    queryKeys.orders.list(accountID, status, side, limit, product),
    () =>
      getOrders({
        accountID: accountID || "",
        paper: product === "paper",
        symbols: [],
        status: status ? status : "all",
        side: side,
        limit,
      }),
    options,
  );

  const emptyOrders = useMemo(() => [], []);

  return { orders: data || emptyOrders, refetch, isLoading };
};

export default useGetOrders;
